<template>
  <v-card>
    <v-toolbar class="toolbar-header-color">
      <v-toolbar-title>
        Register {{branchName}}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark text @click="dialogueClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card-text>
      <v-snackbar v-model="snackbar" color="error" :timeout="callbackResponse.timeout" top>
        {{errorMessage}}
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>

      <v-container>
        <form>
          <v-row>
            <v-col cols="12" md="6">
              <v-select
                v-model="formPostData.UserDetails.provinceId"
                :items="province"
                label="Select Province"
                item-value="id"
                item-text="value"
                :error-messages="provinceIdErrors"
                @input="$v.formPostData.UserDetails.provinceId.$touch()"
                @blur="$v.formPostData.UserDetails.provinceId.$touch()"
              ></v-select>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="formPostData.UserDetails.divisionId"
                :items="division"
                label="Select Division"
                item-value="id"
                item-text="value"
                @change="DivisionChanged"
                :error-messages="divisionIdErrors"
                @input="$v.formPostData.UserDetails.divisionId.$touch()"
                @blur="$v.formPostData.UserDetails.divisionId.$touch()"
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col outlined>
              <v-card class="mx-auto pa-4" outlined>
                <v-app-bar color="blue lighten-1" dark>
                  <v-row justify="center" align="center">
                    <p class="title">{{branchName}} Information</p>
                  </v-row>
                </v-app-bar>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="formPostData.BranchInformation.BranchName"
                      :label="branchName+' Name'"
                      required
                      :error-messages="BranchNameErrors"
                      @input="$v.formPostData.BranchInformation.BranchName.$touch()"
                      @blur="$v.formPostData.BranchInformation.BranchName.$touch()"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" v-if = "isBranchHotel">
                      <v-select v-model="formPostData.BranchInformation.BranchType" :items="items" :label="branchName+' Type'"></v-select>
                  </v-col>
                  <v-col cols="12" v-if = "isTravelTour">
                      <v-select v-model="formPostData.BranchInformation.BranchType" item-text="id" item-value="value" :items="TravelTourTypeList" :label="branchName+' Type'"></v-select>
                  </v-col>
                  <v-col cols="12" v-else-if="isBranchAdventure">
                    <v-select v-model="formPostData.BranchInformation.BranchType" :items="adventureType" :label="branchName+' Type'" item-value="value"
                              item-text="id" ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="formPostData.BranchInformation.BranchAddress"
                      :label="branchName+ ' Address'"
                      required
                      :error-messages="BranchAddressErrors"
                      @input="$v.formPostData.BranchInformation.BranchAddress.$touch()"
                      @blur="$v.formPostData.BranchInformation.BranchAddress.$touch()"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
            <!--        <v-text-field
                      v-model="formPostData.BranchInformation.EstablishedYear"
                      :label="branchName+ ' Estd Year'"
                      required
                      :error-messages="EstablishedYearErrors"
                      @input="$v.formPostData.BranchInformation.EstablishedYear.$touch()"
                      @blur="$v.formPostData.BranchInformation.EstablishedYear.$touch()"
                    ></v-text-field>-->
                    <v-menu
                            v-model="dateMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                                v-model="formPostData.BranchInformation.EstablishedYear"
                                label=" Establishment Year"
                                clearable
                                prepend-icon="event"
                                readonly
                                v-on="on"
                                required
                                :error-messages="EstablishedYearErrors"
                                @input="$v.formPostData.BranchInformation.EstablishedYear.$touch()"
                                @blur="$v.formPostData.BranchInformation.EstablishedYear.$touch()"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="formPostData.BranchInformation.EstablishedYear">

                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" v-if="isBranchCompany">
                    <v-text-field
                      v-model="formPostData.BranchInformation.NumberOfFleet"
                      :label="'Number Of Fleets'"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="formPostData.BranchInformation.BranchEmail"
                      :label="branchName+ ' Email'"
                      required
                      :error-messages="BranchEmailErrors"
                      @input="$v.formPostData.BranchInformation.BranchEmail.$touch()"
                      @blur="$v.formPostData.BranchInformation.BranchEmail.$touch()"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="formPostData.BranchInformation.BranchWebsite"
                      :label="branchName+ ' Website'"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="formPostData.BranchInformation.BranchPhoneNumber"
                      :label="branchName+ ' Phone Number'"
                      required
                      :error-messages="BranchPhoneNumberErrors"
                      @input="$v.formPostData.BranchInformation.BranchPhoneNumber.$touch()"
                      @blur="$v.formPostData.BranchInformation.BranchPhoneNumber.$touch()"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-file-input
                      v-model="formPostData.BranchInformation.Logo"
                      show-size
                      label="Logo"
                      :error-messages="LogoErrors"
                      @input="$v.formPostData.BranchInformation.Logo.$touch()"
                      @blur="$v.formPostData.BranchInformation.Logo.$touch()"
                    ></v-file-input>
                  </v-col>
                  <v-col cols="12">
                    <v-file-input
                      v-model="formPostData.BranchInformation.RegisterDocument"
                      show-size
                      label="Register Document"
                      :error-messages="RegisterDocumentErrors"
                      @input="$v.formPostData.BranchInformation.RegisterDocument.$touch()"
                      @blur="$v.formPostData.BranchInformation.RegisterDocument.$touch()"
                    ></v-file-input>
                  </v-col>
                  <v-col cols="12">
                    <v-file-input
                      v-model="formPostData.BranchInformation.TaxClearanceDocument"
                      show-size
                      label="Tax Clearance Document"
                      :error-messages="TaxClearanceDocumentErrors"
                      @input="$v.formPostData.BranchInformation.TaxClearanceDocument.$touch()"
                      @blur="$v.formPostData.BranchInformation.TaxClearanceDocument.$touch()"
                    ></v-file-input>
                  </v-col>
                  <v-col cols="12">
                    <v-file-input
                      v-model="formPostData.BranchInformation.VatDocument"
                      show-size
                      label="Vat Document"
                      :error-messages="VatDocumentErrors"
                      @input="$v.formPostData.BranchInformation.VatDocument.$touch()"
                      @blur="$v.formPostData.BranchInformation.VatDocument.$touch()"
                    ></v-file-input>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col>
              <v-card class="mx-auto pa-4" outlined>
                <v-app-bar color="blue lighten-1" dark>
                  <v-row justify="center" align="center">
                    <p class="title" justify="center">User Info</p>
                  </v-row>
                </v-app-bar>

                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="formPostData.UserDetails.firstName"
                      label="First Name"
                      required
                      :error-messages="firstNameErrors"
                      @input="$v.formPostData.UserDetails.firstName.$touch()"
                      @blur="$v.formPostData.UserDetails.firstName.$touch()"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="formPostData.UserDetails.lastName"
                      label="Last Name"
                      :error-messages="lastNameErrors"
                      @input="$v.formPostData.UserDetails.lastName.$touch()"
                      @blur="$v.formPostData.UserDetails.lastName.$touch()"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="formPostData.UserDetails.address"
                      label="Address"
                      :error-messages="addressErrors"
                      @input="$v.formPostData.UserDetails.address.$touch()"
                      @blur="$v.formPostData.UserDetails.address.$touch()"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="formPostData.UserDetails.email"
                      label="E-mail"
                      :error-messages="emailErrors"
                      @input="$v.formPostData.UserDetails.email.$touch()"
                      @blur="$v.formPostData.UserDetails.email.$touch()"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="formPostData.UserDetails.userName"
                      label="User Name"
                      :error-messages="userNameErrors"
                      @input="$v.formPostData.UserDetails.userName.$touch()"
                      @blur="$v.formPostData.UserDetails.userName.$touch()"
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="12">
                    <v-file-input
                      v-model="formPostData.BranchInformation.CitizenDocument"
                      show-size
                      label="Citizen Copy"
                    ></v-file-input>
                  </v-col>-->
                  <v-col cols="12">
                    <v-text-field
                      v-model="formPostData.UserDetails.password"
                      label="Password"
                      required
                      type="password"
                      :error-messages="passwordErrors"
                      @input="$v.formPostData.UserDetails.password.$touch()"
                      @blur="$v.formPostData.UserDetails.password.$touch()"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="formPostData.UserDetails.confirmPassword"
                      label="Confirm Pasword"
                      type="password"
                      :error-messages="confirmPasswordErrors"
                      @input="$v.formPostData.UserDetails.confirmPassword.$touch()"
                      @blur="$v.formPostData.UserDetails.confirmPassword.$touch()"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn dark color="red darken-1" @click="dialogueClose">Cancel</v-btn>
      <v-btn class="custom-save-button" @click="submit">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>



<script>
import { email, required, sameAs } from "vuelidate/lib/validators";
import axios from "axios";
export default {
  name: "SignUp",
  props: {
    source: String
  },
  watch: {
    close: {
      handler: function(val) {
        let data = {};
        data.val = val;
        data.type = "close";
        this.$emit("formResponse", val, this.responseData);
        this.close = false;
      },
      deep: true
    },
    "formPostData.UserDetails.provinceId": {
      handler: async function(val,oldVal) {
        if (val !=oldVal) {
          this.error = true;
          this.division = [];
          this.branch = [];
          const divisionBranch = await axios.get("Division/DDLDivisionList", {
            params: { ProvinceID: val }
          });
          this.division = divisionBranch.data;
          this.formPostData.UserDetails.provinceId = val;
        }
      },
      deep: true
    }
  },
  computed: {
    isTravelTour(){
      return this.branchName === 'TravelTour'
    },
    isBranchCompany(){
      return this.branchName === 'Company' || this.branchName === 'Helicopter'
    },
    isBranchHotel(){
      return this.branchName === 'Hotel'
    },
    isBranchAdventure(){
      return this.branchName === 'Adventure'
    },
    provinceIdErrors() {
      const errors = [];
      if (this.error) {
        if (!this.$v.formPostData.UserDetails.provinceId.$dirty) return errors;
        !this.$v.formPostData.UserDetails.provinceId.required &&
          errors.push("Province is required.");
      }
      return errors;
    },
    divisionIdErrors() {
      const errors = [];
      if (this.error) {
        if (!this.$v.formPostData.UserDetails.divisionId.$dirty) return errors;
        !this.$v.formPostData.UserDetails.divisionId.required &&
          errors.push("Province is required.");
      }
      return errors;
    },
    firstNameErrors() {
      const errors = [];
      if (this.error) {
        if (!this.$v.formPostData.UserDetails.firstName.$dirty) return errors;
        !this.$v.formPostData.UserDetails.firstName.required &&
          errors.push("First Name is required.");
      }
      return errors;
    },
    userNameErrors() {
      const errors = [];
      if (this.error) {
        if (!this.$v.formPostData.UserDetails.userName.$dirty) return errors;
        !this.$v.formPostData.UserDetails.userName.required &&
          errors.push("User Name is required.");
      }
      return errors;
    },
    lastNameErrors() {
      const errors = [];
      if (this.error) {
        if (!this.$v.formPostData.UserDetails.lastName.$dirty) return errors;
        !this.$v.formPostData.UserDetails.lastName.required &&
          errors.push("Last Name is required.");
      }
      return errors;
    },
    addressErrors() {
      const errors = [];
      if (this.error) {
        if (!this.$v.formPostData.UserDetails.address.$dirty) return errors;
        !this.$v.formPostData.UserDetails.address.required &&
          errors.push("Address is required.");
      }
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (this.error) {
        if (!this.$v.formPostData.UserDetails.email.$dirty) return errors;
        !this.$v.formPostData.UserDetails.email.email &&
          errors.push("Must be valid e-mail");
        !this.$v.formPostData.UserDetails.email.required &&
          errors.push("E-mail is required");
      }
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (this.error) {
        if (!this.$v.formPostData.UserDetails.password.$dirty) return errors;
        !this.$v.formPostData.UserDetails.password.required &&
          errors.push("Password is required.");
      }
      return errors;
    },
    confirmPasswordErrors() {
      const errors = [];
      if (this.error) {
        if (!this.$v.formPostData.UserDetails.confirmPassword.$dirty)
          return errors;
        !this.$v.formPostData.UserDetails.confirmPassword.required &&
          errors.push("Confirm Password is required.");
        !this.$v.formPostData.UserDetails.confirmPassword.sameAsPassword &&
          errors.push("Password must be identical.");
      }
      return errors;
    },
    BranchPhoneNumberErrors() {
      const errors = [];
      if (this.error) {
        if (!this.$v.formPostData.BranchInformation.BranchPhoneNumber.$dirty)
          return errors;
        !this.$v.formPostData.BranchInformation.BranchPhoneNumber.required &&
          errors.push("Phone number is required.");
      }
      return errors;
    },
    BranchAddressErrors() {
      const errors = [];
      if (this.error) {
        if (!this.$v.formPostData.BranchInformation.BranchAddress.$dirty)
          return errors;
        !this.$v.formPostData.BranchInformation.BranchAddress.required &&
          errors.push("Address is required");
      }
      return errors;
    },
    EstablishedYearErrors() {
      const errors = [];
      if (this.error) {
        if (!this.$v.formPostData.BranchInformation.EstablishedYear.$dirty)
          return errors;
        !this.$v.formPostData.BranchInformation.EstablishedYear.required &&
          errors.push("Establishment Year is required");
      }
      return errors;
    },
    BranchEmailErrors() {
      const errors = [];
      if (this.error) {
        if (!this.$v.formPostData.BranchInformation.BranchEmail.$dirty)
          return errors;
        !this.$v.formPostData.BranchInformation.BranchEmail.email &&
          errors.push("Must be valid e-mail");
        !this.$v.formPostData.BranchInformation.BranchEmail.required &&
          errors.push("E-mail is required");
      }
      return errors;
    },
    BranchNameErrors() {
      const errors = [];
      if (this.error) {
        if (!this.$v.formPostData.BranchInformation.BranchName.$dirty)
          return errors;
        !this.$v.formPostData.BranchInformation.BranchName.required &&
          errors.push("Name is required.");
      }
      return errors;
    },
    LogoErrors() {
      const errors = [];
      if (this.error) {
        if (!this.$v.formPostData.BranchInformation.Logo.$dirty) return errors;
        !this.$v.formPostData.BranchInformation.Logo.required &&
          errors.push("Document is required.");
      }
      return errors;
    },
    RegisterDocumentErrors() {
      const errors = [];
      if (this.error) {
        if (!this.$v.formPostData.BranchInformation.RegisterDocument.$dirty)
          return errors;
        !this.$v.formPostData.BranchInformation.RegisterDocument.required &&
          errors.push("Document is required.");
      }
      return errors;
    },
    TaxClearanceDocumentErrors() {
      const errors = [];
      if (this.error) {
        if (!this.$v.formPostData.BranchInformation.TaxClearanceDocument.$dirty)
          return errors;
        !this.$v.formPostData.BranchInformation.TaxClearanceDocument.required &&
          errors.push("Document is required.");
      }
      return errors;
    },
    VatDocumentErrors() {
      const errors = [];
      if (this.error) {
        if (!this.$v.formPostData.BranchInformation.VatDocument.$dirty)
          return errors;
        !this.$v.formPostData.BranchInformation.VatDocument.required &&
          errors.push("Document is required.");
      }
      return errors;
    }
  },
  validations: {
    formPostData: {
      UserDetails: {
        provinceId: { required },
        divisionId: { required },
        firstName: { required },
        lastName: { required },
        address: { required },
        email: { required, email },
        password: { required },
        userName: { required },
        confirmPassword: {
          required,
          sameAsPassword: sameAs("password")
        }
      },
      BranchInformation: {
        BranchPhoneNumber: { required },
        Logo: { required },
        BranchName: { required },
        RegisterDocument: { required },
        TaxClearanceDocument: { required },
        VatDocument: { required },
        BranchAddress: { required },
        EstablishedYear: { required },
        BranchEmail: { required, email }
      },
    },
  },
  data() {
    return {
      responseData: {},
      callbackResponse: {
        timeout: 6000
      },
      errorMessage: "",
      snackbar: false,
      close: false,
      error: false,
      created: false,
      show1: false,
      show2: false,
      provShow: false,
      divShow: false,
      items: ['Normal', 'Delux', 'Classic', 'Grand', '1 star', '2 star', '3 star', '4 star', '5 star','6 star','7 star'],
      adventureType:[],
      province: [],
      division: [],
      branch: [],
      branchName: "Branch",
      dateMenu: false,
      TravelTourTypeList:[],
      formPostData: {
        BranchInformation: {},
        UserDetails: {}
      },
      servicesData:{
        data:{},
        message:"",
        color:""
      }
    };
  },
  created() {
    this.formData();
    this.error = true;
  },
  destroyed() {},
  methods: {
    dialogueClose() {
      console.log(this.servicesData)
      this.$emit("formResponse", this.servicesData);
    },
    branchMethod(index) {
      console.log(this.division[index]);
    },
    async formData() {
      const adventure = await axios.get("Shared/AdventuresList");
      this.adventureType = adventure.data;
      const provinceRequest = await axios.get("Province/DDLProvinceList");
      this.province = provinceRequest.data;
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.formPostData.isAnonymous = true;
        var form = new FormData();

        form.append(
          "BranchInformation.Logo",
          this.formPostData.BranchInformation.Logo
        );
        form.append(
          "BranchInformation.TaxClearanceDocument",
          this.formPostData.BranchInformation.TaxClearanceDocument
        );
        form.append(
          "BranchInformation.BranchType",
          this.formPostData.BranchInformation.BranchType
        );
        form.append(
          "BranchInformation.VatDocument",
          this.formPostData.BranchInformation.VatDocument
        );
        form.append(
          "BranchInformation.RegisterDocument",
          this.formPostData.BranchInformation.RegisterDocument
        );
        form.append(
          "BranchInformation.BranchName",
          this.formPostData.BranchInformation.BranchName
        );
        form.append(
          "BranchInformation.BranchAddress",
          this.formPostData.BranchInformation.BranchAddress
        );
        form.append(
          "BranchInformation.NumberOfFleet",
          this.formPostData.BranchInformation.NumberOfFleet?this.formPostData.BranchInformation.NumberOfFleet:""
        );
        form.append(
          "BranchInformation.EstablishedYear",
          this.formPostData.BranchInformation.EstablishedYear
        );
        form.append(
          "BranchInformation.BranchPhoneNumber",
          this.formPostData.BranchInformation.BranchPhoneNumber
        );
        form.append(
          "BranchInformation.BranchWebsite",
          this.formPostData.BranchInformation.BranchWebsite
        );
        form.append(
          "BranchInformation.BranchEmail",
          this.formPostData.BranchInformation.BranchEmail
        );
        form.append(
          "BranchInformation.BranchCode",
          this.formPostData.BranchInformation.BranchCode
        );
        form.append(
          "UserDetails.FirstName",
          this.formPostData.UserDetails.firstName
        );
        form.append("UserDetails.MinistryID", 1);
        form.append(
          "UserDetails.LastName",
          this.formPostData.UserDetails.lastName
        );
        form.append(
          "UserDetails.Address",
          this.formPostData.UserDetails.address
        );
        form.append("UserDetails.Email", this.formPostData.UserDetails.email);
        form.append(
          "UserDetails.UserName",
          this.formPostData.UserDetails.userName
        );
        form.append(
          "UserDetails.Password",
          this.formPostData.UserDetails.password
        );
        form.append(
          "UserDetails.DivisionID",
          this.formPostData.UserDetails.divisionId
        );
        form.append(
          "UserDetails.ProvinceID",
          this.formPostData.UserDetails.provinceId
        );
        form.append("isAnonymous", "true");
        this.snackbar = false;
        axios
          .post("User/CreateUser", form)
          .then(response => {
            this.responseData = response.data;
            if (response.data.success) {
              this.editedData = {};
              this.servicesData.data=response.data
              this.servicesData.message="User Register Succcessfully Wait For Confirmation"
              this.servicesData.color="success"
              this.dialogueClose()
            } else {
              console.log(response.data.errors[0]);
              this.errorMessage = response.data.errors[0];
              this.snackbar = true;
            }
          })
          .catch(data => {
            console.log(data);
            this.errorMessage = "Server Error, Please Contact Admin";
            this.snackbar = true;
          });
      }
      this.submitStatus = "PENDING";
      setTimeout(() => {
        this.submitStatus = "OK";
      }, 500);
    },
    async DivisionChanged(index) {
      console.log(index);
      let div = this.division.filter(item => item.id === index);
      this.branchName = div[0].value;
      if(this.branchName == "TravelTour"){
        let type = await axios.get("Shared/GetTravelTourTypeList");
        this.TravelTourTypeList = type.data;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.v-item-group {
  background: #1565c0;
}
input {
  display: none;
}
.v-card--outlined {
  height: 100%;
}
</style>
